
import { useState } from "react";
import { NotificationPanel, useNotifications } from "./NotificationCenter";

export default function Header() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  
  let unreadCount = 0;
  try {
    const notifications = useNotifications();
    unreadCount = notifications.unreadCount;
  } catch {
    // NotificationProvider not available
  }

  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6">
      {/* Search */}
      <div className="flex-1 max-w-xl">
        <div className="relative">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
          <input
            type="text"
            placeholder="Buscar operaciones, clientes, documentos..."
            className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#2F80ED]/20 focus:border-[#2F80ED]"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded">⌘K</span>
        </div>
      </div>

      {/* Right Actions */}
      <div className="flex items-center gap-4">
        {/* Quick Actions */}
        <button className="px-3 py-1.5 bg-gradient-to-r from-[#114B7A] to-[#2F80ED] text-white text-sm rounded-lg hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap flex items-center gap-2">
          <i className="ri-add-line"></i>
          Nueva Operación
        </button>

        {/* Notifications */}
        <div className="relative">
          <button 
            onClick={() => setShowNotifications(!showNotifications)}
            className="relative w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className="ri-notification-3-line text-xl text-gray-600"></i>
            {unreadCount > 0 && (
              <span className="absolute top-1 right-1 w-5 h-5 flex items-center justify-center bg-[#EF4444] text-white text-xs font-bold rounded-full animate-pulse">
                {unreadCount > 9 ? "9+" : unreadCount}
              </span>
            )}
          </button>
          
          <NotificationPanel 
            isOpen={showNotifications} 
            onClose={() => setShowNotifications(false)} 
          />
        </div>

        {/* Messages */}
        <button className="relative w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
          <i className="ri-message-2-line text-xl text-gray-600"></i>
          <span className="absolute top-1 right-1 w-2 h-2 bg-[#10B981] rounded-full"></span>
        </button>

        {/* User Menu */}
        <div className="relative">
          <button 
            onClick={() => setShowUserMenu(!showUserMenu)}
            className="flex items-center gap-3 pl-4 border-l border-gray-200 cursor-pointer"
          >
            <div className="text-right">
              <p className="text-sm font-semibold text-[#0A2A43]">Admin Usuario</p>
              <p className="text-xs text-gray-500">Administrador</p>
            </div>
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#114B7A] to-[#2F80ED] flex items-center justify-center text-white font-semibold">
              AU
            </div>
          </button>

          {showUserMenu && (
            <>
              <div className="fixed inset-0 z-40" onClick={() => setShowUserMenu(false)}></div>
              <div className="absolute right-0 top-14 w-56 bg-white rounded-lg shadow-xl border border-gray-100 z-50 py-2">
                <a href="/settings" className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 cursor-pointer">
                  <i className="ri-user-line text-gray-500"></i>
                  <span className="text-sm text-gray-700">Mi Perfil</span>
                </a>
                <a href="/settings" className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 cursor-pointer">
                  <i className="ri-settings-3-line text-gray-500"></i>
                  <span className="text-sm text-gray-700">Configuración</span>
                </a>
                <hr className="my-2 border-gray-100" />
                <button className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-left">
                  <i className="ri-logout-box-line text-[#EF4444]"></i>
                  <span className="text-sm text-[#EF4444]">Cerrar Sesión</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
